<div class="company-container">
  <div class="top-part">
    <div class="top-part-wrap">
      <div class="first-section d-flex align-items-center">
        <h5 class="mb-0 table-title">Barcode Management</h5>
      </div>
      <div class="first-section d-flex align-items-center">
        <span class="ms-3">Barcodes <span>: </span><span data-testid="barcode-count">{{
            barcodeData.length
            }}</span></span>
      </div>
      <div class="second-section d-flex align-items-center justify-content-end" id="customDrpdown">
        <span *ngxPermissionsOnly="['Item:ScanPull']" matTooltip="Import Scan Pull" matTooltipPosition="above">
          <button class="btn filter-btn me-2" aria-label="ImportScanPull" (click)="openImportDialog()"
            [disabled]="isScanPullInProgress || isImportInProgress" data-testid="import-scan-pull-btn">
            <i class="fa-solid fa-file-import" style="color: #175f91; font-size: 22px"></i>
          </button>
        </span>
        <input class="d-none" #importScanPullInput type="file" accept=".csv, .xlsx, .xls"
          (change)="onImportFileSelected($event)" data-testid="import-scan-pull-input" />
        <span *ngxPermissionsOnly="['Item:ScanPull']" matTooltip="Scan Pull Selected Barcode(s)"
          matTooltipPosition="above">
          <button class="btn filter-btn me-2" data-toggle="modal" data-target="#scanPullModal"
            aria-label="OpenScanPullModal" (click)="scanpullAllBarcode()"
            [disabled]="isScanPullInProgress || isImportInProgress" data-testid="bulk-scan-pull-btn">
            <i class="fa-solid fa-box-archive" style="color: #175f91; font-size: 22px"></i>
          </button>
        </span>
        <span *ngxPermissionsOnly="['History:Delete']" matTooltip="Delete Selected Barcode(s)"
          matTooltipPosition="above">
          <button class="btn filter-btn" data-toggle="modal" data-target="#deleteDataModal" aria-label="OpenDeleteModal"
            (click)="deleteAllBarcode()" data-testid="bulk-delete-btn">
            <img style="width: 22px" src="../../../assets/Pricingscreen/delete.svg" />
          </button>
        </span>
        <span matTooltip="Reprint Selected Barcode(s)" matTooltipPosition="above">
          <button class="btn filter-btn me-2" data-toggle="modal" data-target="#reprintModal"
            aria-label="OpenReprintModal" (click)="reprintAllBarcode()" data-testid="bulk-reprint-btn">
            <i class="fa-solid fa-print" style="color: #175f91; font-size: 22px"></i>
          </button>
        </span>
        <div class="searchbar d-flex ms-2">
          <img class="search me-2" src="../../../assets/icons/searchbar.svg" />
          <input type="text" placeholder="Search Barcode" [(ngModel)]="barcode" (keyup.enter)="searchBarcode()"
            data-testid="search-barcode-input" />
        </div>
        <div class="create-btn add-btn ms-2" (click)="searchBarcode()" data-testid="search-barcode-btn">
          Search
        </div>
      </div>
    </div>
  </div>

  <section class="intro">
    <div class="table-container">
      <table class="table category-table table-condensed">
        <thead class="main-head sticky-top">
          <tr>
            <th scope="col" class="text-trasnform">
              <input style="
                  height: 20px;
                  width: 20px;
                  margin-right: 10px;
                  margin-top: 0;
                " class="form-check-input" id="flexCheckDefault1" type="checkbox" [(ngModel)]="selectAllChecked"
                (change)="toggleBarcodes($event)" data-testid="select-all-checkbox" />
              Barcode
            </th>
            <th scope="col" class="text-trasnform">Department</th>
            <th scope="col" class="text-trasnform">Category</th>
            <th scope="col" class="text-trasnform">Subcategory</th>
            <th scope="col" class="text-trasnform">Store</th>
            <th scope="col" class="text-trasnform" style="text-align: right; padding-right: 30px">
              Pieces
            </th>
            <th *ngIf="showWeekColor" scope="col" class="text-trasnform">
              Week Color
            </th>
            <th *ngIf="showWeekColor" scope="col" class="text-trasnform">
              Week Color
            </th>
            <th scope="col" class="text-trasnform">Created Date</th>
            <th scope="col" class="text-trasnform">Date Produced For</th>
            <th scope="col" class="text-trasnform">Produced at</th>
            <th scope="col" class="text-trasnform">Produced By</th>
            <th scope="col" class="text-trasnform">Scan Pulled By</th>
            <th scope="col" class="text-trasnform" style="text-align: right; padding-right: 30px">
              Price
            </th>
            <th scope="col" class="text-trasnform">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let barcode of barcodeData; let i = index; trackBy: trackByBarcode" data-testid="barcode-row">
            <td style="font-size: 14px; font-weight: 700">
              <input style="
                  height: 20px;
                  width: 20px;
                  margin-right: 10px;
                  margin-top: 0;
                " class="form-check-input" id="flexCheckDefault1" type="checkbox" [(ngModel)]="barcode.isSelected"
                data-testid="row-checkbox" [disabled]="barcode.isScanPull || barcode.isDeleted" />
              <span data-testid="row-barcode">{{ barcode.barcode }}</span>
              <span *ngIf="barcode.isScanPull" style="
                  background-color: #e8f5e9;
                  color: #2e7d32;
                  padding: 2px 8px;
                  border-radius: 4px;
                  font-size: 9px;
                  margin-left: 8px;
                  font-weight: 600;
                  border: 1px solid #c8e6c9;
                ">
                Scan Pulled
              </span>
              <span *ngIf="barcode.isDeleted" style="
                  background-color: #ffebee;
                  color: #c62828;
                  padding: 2px 8px;
                  border-radius: 4px;
                  font-size: 9px;
                  margin-left: 8px;
                  font-weight: 600;
                  border: 1px solid #ffcdd2;
                ">
                Deleted
              </span>
            </td>
            <td class="ps-2">
              <div class="d-flex align-items-center" style="gap: 7px">
                {{ barcode.departmentDescr }}
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center" style="gap: 7px">
                {{ barcode.categoryName }}
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center" style="gap: 7px">
                {{ barcode.subCategoryName || "-" }}
              </div>
            </td>
            <td>{{ barcode.storeName }}</td>
            <td style="text-align: right; padding-right: 30px">
              {{ barcode.numberOfPieces }}
            </td>
            <td *ngIf="showWeekColor">
              <span class="bgColor" [style.backgroundColor]="barcode.color"></span>
            </td>
            <td>{{ barcode.dateCreated | date: "MM/dd/yyyy h:mm a" }}</td>
            <td>{{ (barcode.producedForDate | date: "MM/dd/yyyy") || "-" }}</td>
            <td>{{ barcode.locationName || "-" }}</td>
            <td>{{ barcode.userName || "-" }}</td>
            <td>{{ barcode.isScanPull ? (barcode.lastUpdatedByUserName || '-') : '-' }}</td>
            <td style="text-align: right; padding-right: 30px">
              {{ barcode.price | currency }}
            </td>
            <td>
              <div class="d-flex align-items-center" style="gap: 15px">
                <button *ngxPermissionsOnly="['Item:ScanPull']" type="button" class="action-drop d-flex scan-pull-btn"
                  matTooltip="Scan Pull" matTooltipPosition="above" (click)="scanpullSingleBarcode(barcode.barcode)"
                  data-testid="row-scan-pull-btn" [disabled]="barcode.isScanPull || barcode.isDeleted">
                  <i class="fa-solid fa-box-archive action-icon" [ngClass]="{
                      'icon-disabled': barcode.isScanPull || barcode.isDeleted
                    }"></i>
                </button>
                <button *ngxPermissionsOnly="['History:Delete']" type="button" class="action-drop d-flex"
                  matTooltip="Delete" matTooltipPosition="above" (click)="deleteSingleBarcode(barcode.barcode)"
                  data-testid="row-delete-btn" [disabled]="barcode.isDeleted">
                  <i class="fa-solid fa-trash-can action-icon" [ngClass]="{ 'icon-disabled': barcode.isDeleted }"></i>
                </button>
                <button type="button" class="action-drop d-flex" matTooltip="Reprint" matTooltipPosition="above"
                  (click)="reprintSingleBarcode(barcode.barcode)" data-testid="row-reprint-btn"
                  [disabled]="barcode.isDeleted">
                  <i class="fa-solid fa-print action-icon" [ngClass]="{ 'icon-disabled': barcode.isDeleted }"></i>
                </button>
                <button style="all: unset; cursor: pointer" matTooltip="Remove from List" matTooltipPosition="above"
                  (click)="removeFromList(i)" data-testid="row-remove-btn" class="d-flex">
                  <i class="fa-solid fa-right-from-bracket action-icon"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>

<!--Modal for Scan Pull -->
<div class="modal fade" id="scanPullModal" aria-hidden="true" aria-labelledby="scanPullModalLabel" tabindex="-1"
  data-testid="scan-pull-modal">
  <div class="modal-dialog modal-dialog-centered modal-md" style="width: 500px !important">
    <div class="modal-content">
      <div class="modal-header" *ngIf="scanPullModalHasSelection">
        <h5>Scan Pull</h5>
      </div>
      <div class="modal-header" *ngIf="!scanPullModalHasSelection">
        <h5>No Barcode(s) Selected !</h5>
      </div>
      <div class="modal-body" *ngIf="scanPullModalHasSelection">
        <div class="modal-body-wraapper">
          <p>
            Are you sure you want to scan pull the "Selected Barcode(s)"?<br />
          </p>
          <p class="fw-bold mt-3">
            Once confirmed, all the selected barcodes will be scanned and
            pulled.
          </p>
        </div>
      </div>
      <div class="modal-body" *ngIf="!scanPullModalHasSelection">
        <div class="modal-body-wraapper">
          <p>Please select one or more Barcode(s) to scan pull.</p>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer">
        <button #scanPullModalCloseButton class="btn modal-btn me-2" data-dismiss="modal" aria-label="Close">
          Close
        </button>
        <button class="btn modal-btn" aria-label="Close" *ngIf="scanPullModalHasSelection"
          style="background-color: rgb(23, 95, 145); color: white" (click)="confirmScanPull()"
          data-testid="confirm-scan-pull-btn">
          Yes, Scan Pull
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isScanPullInProgress" class="scanpull-loader-overlay">
  <div class="scanpull-loader-card">
    <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
    Processing scan pull...
  </div>
</div>

<div *ngIf="isImportInProgress" class="scanpull-loader-overlay">
  <div class="scanpull-loader-card" data-testid="import-progress">
    <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
    {{ importProgressText }}
  </div>
</div>

<!--Modal for Reprint -->
<div class="modal fade" id="reprintModal" aria-hidden="true" aria-labelledby="reprintModalLabel" tabindex="-1"
  data-testid="reprint-modal">
  <div class="modal-dialog modal-dialog-centered modal-md" style="width: 500px !important">
    <div class="modal-content">
      <div class="modal-header" *ngIf="reprintModalHasSelection">
        <h5>Reprint Barcodes</h5>
      </div>
      <div class="modal-header" *ngIf="!reprintModalHasSelection">
        <h5>No Barcode(s) Selected !</h5>
      </div>
      <div class="modal-body" *ngIf="reprintModalHasSelection">
        <div class="modal-body-wraapper">
          <p>
            Are you sure you want to reprint the "Selected Barcode(s)"?<br />
          </p>
          <p class="fw-bold mt-3">
            Once confirmed, all the selected barcodes will be sent to the
            printer.
          </p>
        </div>
      </div>
      <div class="modal-body" *ngIf="!reprintModalHasSelection">
        <div class="modal-body-wraapper">
          <p>Please select one or more Barcode(s) to reprint.</p>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer">
        <button #reprintModalCloseButton class="btn modal-btn me-2" data-dismiss="modal" aria-label="Close">
          Close
        </button>
        <button class="btn modal-btn" aria-label="Close" *ngIf="reprintModalHasSelection"
          style="background-color: rgb(23, 95, 145); color: white" (click)="confirmReprint()"
          data-testid="confirm-reprint-btn">
          Yes, Reprint
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isReprintInProgress" class="scanpull-loader-overlay">
  <div class="scanpull-loader-card">
    <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
    Processing reprint...
  </div>
</div>

<!--Modal for Delete -->
<div class="modal fade" id="deleteDataModal" aria-hidden="true" aria-labelledby="deleteModalLabel" tabindex="-1"
  data-testid="delete-modal">
  <div class="modal-dialog modal-dialog-centered modal-md" style="width: 500px !important">
    <div class="modal-content">
      <div class="modal-header" *ngIf="deleteModalHasSelection">
        <h5>Delete Barcodes</h5>
      </div>
      <div class="modal-header" *ngIf="!deleteModalHasSelection">
        <h5>No Barcode(s) Selected !</h5>
      </div>
      <div class="modal-body" *ngIf="deleteModalHasSelection">
        <div class="modal-body-wraapper">
          <p>
            Are you sure you want to delete the "Selected Barcode(s)" from
            history?<br />
          </p>
          <p class="fw-bold mt-3">
            Once confirmed, all the selected barcodes will be permanently
            deleted from history.
          </p>
        </div>
      </div>
      <div class="modal-body" *ngIf="!deleteModalHasSelection">
        <div class="modal-body-wraapper">
          <p>Please select one or more Barcode(s) to delete.</p>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer">
        <button class="btn modal-btn me-2" data-dismiss="modal" aria-label="Close">
          Close
        </button>
        <button class="btn modal-btn" data-dismiss="modal" aria-label="Close" *ngIf="deleteModalHasSelection"
          style="background-color: rgb(23, 95, 145); color: white" (click)="confirmDelete()"
          data-testid="confirm-delete-btn">
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Failed Operation Modal -->
<div class="modal fade" [class.show]="showFailedScanPullModal"
  [style.display]="showFailedScanPullModal ? 'block' : 'none'" id="failedScanPullModal" tabindex="-1" role="dialog"
  aria-labelledby="failedScanPullModalLabel" aria-hidden="true" data-testid="failed-operation-modal">
  <div class="modal-dialog modal-dialog-centered modal-mg" role="document">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #f8d7da; border-bottom: 2px solid #f5c6cb">
        <h5 class="modal-title" id="failedScanPullModalLabel" style="color: #721c24; font-weight: 600">
          <i class="fa fa-exclamation-triangle me-2"></i>Operation Results
        </h5>
        <button type="button" class="btn-close" (click)="closeFailedScanPullModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="alert alert-warning mb-3" role="alert">
          <strong>Summary:</strong> {{ scanPullSuccessCount }} barcode(s)
          processed successfully, {{ failedToScanPullSerials.length }} failed.
        </div>
        <h6 class="mb-3" style="color: #721c24; font-weight: 600">
          Failed Operations:
        </h6>
        <div style="max-height: 400px; overflow-y: auto">
          <table class="table table-sm table-bordered">
            <thead style="
                position: sticky;
                top: 0;
                background-color: #f8f9fa;
                z-index: 1;
              ">
              <tr>
                <th style="border: 1px solid #dee2e6; padding: 8px; width: 40%">
                  Serial Number
                </th>
                <th style="border: 1px solid #dee2e6; padding: 8px; width: 60%">
                  Error Message
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let failed of failedToScanPullSerials">
                <td style="
                    border: 1px solid #dee2e6;
                    padding: 8px;
                    vertical-align: top;
                  ">
                  {{ failed.serialNumber }}
                </td>
                <td style="
                    border: 1px solid #dee2e6;
                    padding: 8px;
                    vertical-align: top;
                    color: #721c24;
                  ">
                  {{ failed.message }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn modal-btn" style="background-color: #175f91; color: white"
          (click)="closeFailedScanPullModal()" data-testid="close-failed-modal-btn">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Scan Pull Import Report Modal -->
<div class="modal fade" [class.show]="showImportReportModal" [style.display]="showImportReportModal ? 'block' : 'none'"
  id="scanPullImportReportModal" tabindex="-1" role="dialog" aria-labelledby="scanPullImportReportModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" role="document">
    <div class="modal-content" *ngIf="importReport">
      <div class="modal-header">
        <h5 class="modal-title" id="scanPullImportReportModalLabel" style="color: #175f91; font-weight: 600">
          <i class="fa-solid fa-file-import me-2"></i>Scan Pull Import
        </h5>
        <button type="button" class="btn-close" (click)="closeImportReportModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p class="import-report-file mb-3">
          <strong>File:</strong> {{ importReport.fileName }}
        </p>

        <div class="import-report-summary mb-3">
          <div class="import-report-tile">
            <span class="import-report-label">Barcodes in File</span>
            <span class="import-report-value" data-testid="import-rows">{{ importReport.rowsInFile }}</span>
          </div>
          <div class="import-report-tile">
            <span class="import-report-label">Unique Barcodes</span>
            <span class="import-report-value" data-testid="import-unique">{{ importReport.uniqueBarcodes }}</span>
          </div>
          <div class="import-report-tile import-report-tile-success">
            <span class="import-report-label">Scan Pulled</span>
            <span class="import-report-value" data-testid="import-success">{{ importReport.scanPulledCount }}</span>
          </div>
          <div class="import-report-tile import-report-tile-failed">
            <span class="import-report-label">Not Scan Pulled</span>
            <span class="import-report-value" data-testid="import-failed">{{ importReport.failedCount }}</span>
          </div>
        </div>

        <div *ngIf="importReport.stoppedEarly" class="alert alert-danger" role="alert"
          data-testid="import-stopped-early">
          <strong>Import stopped before completing.</strong>
          {{ importReport.errorMessage }}
          Any remaining barcodes in the file were not processed.
        </div>

        <ng-container *ngIf="importReport.failedCount > 0">
          <h6 class="mb-3" style="color: #721c24; font-weight: 600">
            Barcodes Not Scan Pulled:
          </h6>

          <!-- The modal body is the scroll region (modal-dialog-scrollable), so this
               table just flows and its sticky header sticks to the body. -->
          <div>
            <table class="table table-sm table-bordered">
              <thead style="position: sticky; top: 0; background-color: #f8f9fa; z-index: 1">
                <tr>
                  <th style="border: 1px solid #dee2e6; padding: 8px; width: 40%">
                    Barcode
                  </th>
                  <th style="border: 1px solid #dee2e6; padding: 8px; width: 60%">
                    Reason
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let failed of importReport.failures">
                  <td style="border: 1px solid #dee2e6; padding: 8px; vertical-align: top">
                    {{ failed.serialNumber }}
                  </td>
                  <td style="border: 1px solid #dee2e6; padding: 8px; vertical-align: top; color: #721c24">
                    {{ failed.message }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>

        <div *ngIf="importReport.failedCount === 0 && !importReport.stoppedEarly" class="alert alert-success mb-0"
          role="alert">
          Every barcode in the file was scan pulled successfully.
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn modal-btn" style="background-color: #175f91; color: white"
          (click)="closeImportReportModal()" data-testid="close-import-report-btn">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal backdrop -->
<div class="modal-backdrop fade" [class.show]="showFailedScanPullModal || showImportReportModal"
  [style.display]="showFailedScanPullModal || showImportReportModal ? 'block' : 'none'"></div>
